var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$gameData.images.background)?_c('div',{staticClass:"background"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }